import React, { use } from "react";
import { useState,useEffect,useRef } from "react";
import post from "../post";
import { useLocation as location2 } from "wouter";
import { MapContainer,TileLayer,Marker,useMapEvents,useMap } from "react-leaflet";
import Loading from "../components/Loading";
import Alert from "../components/Alert";
import Confirm from "../components/Confirm";
//import L from 'leaflet';
import { useDebounce,useDebouncedCallback } from "use-debounce";
function ChangeView({ center, zoom,rerender}) {
      const map = useMap();
      useEffect(()=>{
        map.setView(center, zoom);
      },[center,rerender])
      return null; // This component does not render anything visually
}


const EditAddress = (props) => {
    //get id from url
    const id = props.params.id;
    const [loading, setLoading] = useState(false);
    const [location, navigate] = location2();
    const [data, setData] = useState({});
    const coords=useRef({lat:19.418248,lng:-99.158798});
    const [dbounced]=useDebounce(data,1000);
    const [canDebounce,setCanDebounce]=useState(false);
    const [mapRender,setMapRender]=useState(0);
    const [alert,setAlert]=useState(null);
    const [eliminarDir,setEliminarDir]=useState(false);


    const guardarDireccion=async()=>{
        //save address data to api
        
        if(!data.name || !data.calle || !data.ext || !data.colonia || !data.delegacion || !data.estado || !data.cp){
            setAlert({ isOpen: true, title: 'Error', message: 'Por favor, completa todos los campos obligatorios.' ,onClose:()=>{setAlert(null);}});
            return;
        }
        if(!coords.current.lat || !coords.current.lng){
            setAlert({ isOpen: true, title: 'Error', message: 'Por favor, ajusta la ubicación en el mapa.' ,onClose:()=>{setAlert(null);}});
            return;
        }
        setLoading(true);
        const response=await post('saveAddress',{
            id:id,
            nombre:data.name,
            calle:data.calle,
            ext:data.ext,
            int:data.int,
            colonia:data.colonia,
            delegacion:data.delegacion,
            estado:data.estado,
            cp:data.cp,
            comentarios:data.comentarios,
            lat:coords.current.lat,
            lng:coords.current.lng
        });
        setLoading(false);
        if(!response.result){
            setAlert({ isOpen: true, title: 'Error', message: response.motive || 'Error al guardar la dirección. Por favor, intenta de nuevo.' ,onClose:()=>{setAlert(null);}});
            return;
        }
        navigate('/profile');
    }
    
    useEffect(()=>{
       if(!canDebounce) return;
        //geocode  address
        const key="AIzaSyD7ZLaa6o0H4xy5DL70eNsJhodnBcdapG0";
        let url="https://maps.googleapis.com/maps/api/geocode/json?";
        const address=`${dbounced.calle??''} ${dbounced.ext??''}, ${dbounced.colonia??''} ${dbounced.delegacion??''} ${dbounced.estado??''} ${dbounced.cp??''}`;
        if(address=='' || (dbounced.calle??'')=='' || (dbounced.colonia??'')=='') return;
        url+=`address=${encodeURI(address)}&region=mx&key=${key}`;
        const fetchGC=async (url)=>{
            const r=await fetch(url);
            const d=await r.json();
            if(d.status=='OK'){
               coords.current={
                    lat:d.results[0].geometry.location.lat,
                    lng:d.results[0].geometry.location.lng
                }
                
                setMapRender(mapRender+1);
            }
        };
        fetchGC(url);
    },[dbounced])



    useEffect(() => {
        //fetch address data from api
        if(id==0){
            setCanDebounce(true);
            return;
        } 
        const fetchData = async () => {
            setLoading(true);
            const response = await post("getAddress", { id: id });
            if (!response.result) {
                setAlert({ isOpen: true, title: 'Error', message: response.motive || 'Error al obtener la dirección. Por favor, intenta de nuevo.' ,onClose:()=>{
                    navigate('/profile');
                }});
                setLoading(false);
                return;
            }
            setData({
                name: response.data.nombre,
                calle: response.data.calle,
                ext: response.data.ext,
                int: response.data.int,
                colonia: response.data.colonia,
                delegacion: response.data.delegacion,
                estado: response.data.estado,
                cp: response.data.cp,
                comentarios: response.data.comentarios
            });
            if(response.data.lat && response.data.lng){
                    coords.current={lat:response.data.lat,lng:response.data.lng};
                    setMapRender(mapRender+1);
            }
            window.setTimeout(()=>{
                setCanDebounce(true);
            },1500);
            setLoading(false);
        };
        fetchData();
    }, [id]);
    const MapEventHandler=()=>{
        const map=useMapEvents({
        
            moveend:() => {
                const center=map.getCenter();
                coords.current={lat: center.lat, lng: center.lng};
                //setCoords({ lat: center.lat, lon: center.lng });
                
            }
        });
        return null;
    }
    const handleDelete=async()=>{
        setLoading(true);
        setEliminarDir({isOpen:false});
        const response=await post('deleteAddress',{id:id});
        setLoading(false);
        if(!response.result){
            setAlert({ isOpen: true, title: 'Error', message: response.motive || 'Error al eliminar la dirección. Por favor, intenta de nuevo.' ,onClose:()=>{setAlert(null);}});
            return;
        }
        navigate('/profile');
    }

    return (
        <div id="webcrumbs">

            <div className="min-h-screen bg-gradient-to-b from-primary-50 to-white relative pb-16 flex flex-col items-center justify-center">
                <Loading isOpen={loading} />
                <Alert isOpen={alert?.isOpen} title={alert?.title || ''} message={alert?.message || ''} onClose={() => {(alert?.onClose && alert.onClose()); }} />
                <Confirm
                    isOpen={eliminarDir?.isOpen || false}
                    title="Eliminar dirección"
                    message="¿Estás seguro de que deseas eliminar esta dirección?"
                    onClose={() => setEliminarDir({ isOpen: false })}
                    onConfirm={handleDelete}
                    confirmText="Eliminar"
                />
                <div className="w-full max-w-lg px-6 py-10">
                    <div className="flex flex-col items-center mb-8">
                        <div className="w-16 h-16 bg-primary-600 rounded-full flex items-center justify-center mb-4 shadow-lg transform hover:rotate-12 transition-all">
                            <span className="material-symbols-outlined text-white text-3xl">location_on</span>
                        </div>
                        <p className="text-neutral-600 text-center">Edita la información de tu dirección de entrega</p>
                    </div>

                    <div className="bg-white rounded-2xl shadow-sm border border-neutral-100 p-6 mb-6 backdrop-blur-sm">
                        
                        <form className="space-y-4">
                            <div className="space-y-2">
                                <label htmlFor="name" className="block text-sm font-medium text-neutral-700">
                                    Nombre completo
                                </label>
                                <div className="relative">
                                    <span className="absolute inset-y-0 left-3 flex items-center text-neutral-400">
                                        <span className="material-symbols-outlined text-xl">person</span>
                                    </span>
                                    <input
                                        type="text"
                                        id="name"
                                        className="w-full pl-10 pr-4 py-3 border border-neutral-200 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none transition-all bg-neutral-50 placeholder-neutral-400 text-neutral-700"
                                        placeholder="Juan Pérez"
                                        value={data?.name || ''}
                                        onChange={(e) => setData({ ...data, name: e.target.value })}
                                    />
                                </div>
                            </div>
                             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div className="space-y-2">
                                    <label htmlFor="calle" className="block text-sm font-medium text-neutral-700">
                                        Calle
                                    </label>
                                    <div className="relative">
                                        <span className="absolute inset-y-0 left-3 flex items-center text-neutral-400">
                                            <span className="material-symbols-outlined text-xl">signpost</span>
                                        </span>
                                        <input
                                            type="text"
                                            id="calle"
                                            className="w-full pl-10 pr-4 py-3 border border-neutral-200 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none transition-all bg-neutral-50 placeholder-neutral-400 text-neutral-700"
                                            placeholder="Av. Insurgentes Sur"
                                            value={data?.calle || ''}
                                            onChange={(e) => setData({ ...data, calle: e.target.value })}
                                        />
                                    </div>
                                </div>

                                
                            </div>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div className="space-y-2">
                                    <label htmlFor="num-ext" className="block text-sm font-medium text-neutral-700">
                                        Número Exterior
                                    </label>
                                    <div className="relative">
                                        <span className="absolute inset-y-0 left-3 flex items-center text-neutral-400">
                                            <span className="material-symbols-outlined text-xl">tag</span>
                                        </span>
                                        <input
                                            type="text"
                                            id="num-ext"
                                            className="w-full pl-10 pr-4 py-3 border border-neutral-200 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none transition-all bg-neutral-50 placeholder-neutral-400 text-neutral-700"
                                            placeholder="1234"
                                            value={data?.ext || ''}
                                            onChange={(e) => setData({ ...data, ext: e.target.value })}
                                        />
                                    </div>
                                </div>

                                <div className="space-y-2">
                                    <label htmlFor="num-int" className="block text-sm font-medium text-neutral-700">
                                        Número Interior (opcional)
                                    </label>
                                    <div className="relative">
                                        <span className="absolute inset-y-0 left-3 flex items-center text-neutral-400">
                                            <span className="material-symbols-outlined text-xl">door_front</span>
                                        </span>
                                        <input
                                            type="text"
                                            id="num-int"
                                            className="w-full pl-10 pr-4 py-3 border border-neutral-200 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none transition-all bg-neutral-50 placeholder-neutral-400 text-neutral-700"
                                            placeholder="Depto 301"
                                            value={data?.int || ''}
                                            onChange={(e) => setData({ ...data, int: e.target.value })}
                                        />
                                    </div>
                                </div>
                            <div className="space-y-2">
                                <label htmlFor="colonia" className="block text-sm font-medium text-neutral-700">
                                    Colonia
                                </label>
                                <div className="relative">
                                    <span className="absolute inset-y-0 left-3 flex items-center text-neutral-400">
                                        <span className="material-symbols-outlined text-xl">home_work</span>
                                    </span>
                                    <input
                                        type="text"
                                        id="colonia"
                                        className="w-full pl-10 pr-4 py-3 border border-neutral-200 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none transition-all bg-neutral-50 placeholder-neutral-400 text-neutral-700"
                                        placeholder="Del Valle"
                                        value={data?.colonia || ''}
                                        onChange={(e) => setData({ ...data, colonia: e.target.value })}
                                    />
                                </div>
                            </div>
                            <div className="space-y-2">
                                <label htmlFor="delegacion" className="block text-sm font-medium text-neutral-700">
                                    Delegación/Municipio
                                </label>
                                <div className="relative">
                                    <span className="absolute inset-y-0 left-3 flex items-center text-neutral-400">
                                        <span className="material-symbols-outlined text-xl">apartment</span>
                                    </span>
                                    <input
                                        type="text"
                                        id="delegacion"
                                        className="w-full pl-10 pr-4 py-3 border border-neutral-200 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none transition-all bg-neutral-50 placeholder-neutral-400 text-neutral-700"
                                        placeholder="Benito Juárez"
                                        value={data?.delegacion || ''}
                                        onChange={(e) => setData({ ...data, delegacion: e.target.value })}
                                    />
                                </div>
                            </div>
                            <div className="space-y-2">
                                <label htmlFor="delegacion" className="block text-sm font-medium text-neutral-700">
                                    Estado
                                </label>
                                <div className="relative">
                                    <span className="absolute inset-y-0 left-3 flex items-center text-neutral-400">
                                        <span className="material-symbols-outlined text-xl">map</span>
                                    </span>
                                   <select className="form-select appearance-none w-full  pl-10 pr-4 py-3 border border-neutral-200 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none transition-all bg-neutral-50 placeholder-neutral-400 text-neutral-700 "
                                    onChange={(e) => setData({ ...data, estado: e.target.value })}
                                    value={data?.estado || ''}
                                   >
                                    <option value="" disabled>Selecciona un estado</option>
                                    <option value="CDMX" >Ciudad de México</option>
                                    <option value="Puebla" >Puebla</option>
                                   </select>
                                </div>
                            </div>

                            

                           

                            
                                <div className="space-y-2">
                                    <label htmlFor="cp" className="block text-sm font-medium text-neutral-700">
                                        Código Postal
                                    </label>
                                    <div className="relative">
                                        <span className="absolute inset-y-0 left-3 flex items-center text-neutral-400">
                                            <span className="material-symbols-outlined text-xl">
                                                markunread_mailbox
                                            </span>
                                        </span>
                                        <input
                                            type="text"
                                            id="cp"
                                            className="w-full pl-10 pr-4 py-3 border border-neutral-200 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none transition-all bg-neutral-50 placeholder-neutral-400 text-neutral-700"
                                            placeholder="03100"
                                            value={data?.cp || ''}
                                            onChange={(e) => setData({ ...data, cp: e.target.value })}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="space-y-2">
                                <label htmlFor="comments" className="block text-sm font-medium text-neutral-700">
                                    Comentarios adicionales
                                </label>
                                <div className="relative">
                                    <span className="absolute top-3 left-3 flex items-start text-neutral-400">
                                        <span className="material-symbols-outlined text-xl">notes</span>
                                    </span>
                                    <textarea
                                        id="comments"
                                        rows="3"
                                        className="w-full pl-10 pr-4 py-3 border border-neutral-200 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none transition-all bg-neutral-50 placeholder-neutral-400 text-neutral-700 resize-none"
                                        placeholder="Instrucciones de entrega, referencias, etc."
                                        onChange={(e) => setData({ ...data, comentarios: e.target.value })}
                                        value={data?.comentarios || ''}
                                    ></textarea>
                                </div>
                            </div>
                             <div className="text-sm font-medium text-neutral-700">Mueve el mapa para ajustar la ubicación:</div>
                                <div className="mt-6 rounded-xl overflow-hidden border border-neutral-200 h-[240px] relative ">
                           
                                <div className=" inset-0 bg-neutral-100 flex items-center justify-center " >

                                    <MapContainer center={ [coords.current.lat ?? 19.418248, coords.current.lng ?? -99.158798]} zoom={17} scrollWheelZoom={false} className="h-[240px] w-full "
                                    >
                                        <ChangeView center={[coords.current.lat ?? 19.418248, coords.current.lng ?? -99.158798]}  rerender={mapRender} />
                                        <TileLayer className=""
                                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                        />
                                          <img src="https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png" className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-full z-[400]" />
                                        <MapEventHandler />
                                        
                                    </MapContainer>
                                   
                                </div>
                               
                            </div>
                            

                            

                            <div className="grid grid-cols-2 gap-4 mt-6">
                                <button
                                    type="button"
                                    className="w-full bg-neutral-200 text-neutral-800 py-3.5 rounded-xl font-medium shadow-sm hover:bg-neutral-300 transition-all transform hover:scale-[1.01] active:scale-[0.99]"
                                    onClick={() => navigate('/profile')}
                                >
                                    Cancelar
                                </button>
                                <button
                                    type="button"
                                    className="w-full bg-primary-600 text-white py-3.5 rounded-xl font-medium shadow-sm hover:bg-primary-700 transition-all transform hover:scale-[1.01] active:scale-[0.99]"
                                    onClick={guardarDireccion}
                                >
                                    Guardar dirección
                                </button>
                            </div>
                           
                        </form>
                            <div className="mt-10 text-center d-flex  justify-center" >
                                <div className="text-[red] p-4 cursor-pointer" 
                                    onClick={()=>{
                                        setEliminarDir({isOpen:true})
                                    }}
                                >Eliminar dirección</div>
                            </div>
                        <div></div>

                        <div></div>
                    </div>

                    <div></div>

                    <div></div>
                </div>
            </div>
        </div>
    )
}

export default EditAddress;